/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */

import { CytoscapeElements, GraphData, GraphEdge, GraphNode } from '../types';
import { laIdTypeColorAssignment } from '../laIdTypeColorAssignment';

export function getCytoscapeElementsFromGraphData({
  nodes,
  edges,
  sourceNodeId,
}: GraphData): CytoscapeElements {
  return [
    ...getDataColoredEdges(edges, nodes),
    ...getDataColoredNodes(nodes, sourceNodeId),
  ];
}

function getDataColoredNodes(nodes: GraphNode[], sourceNodeId: string) {
  const styledNodes = nodes.map((e) => {
    const { color, label } = laIdTypeColorAssignment.getItem(e.type);
    return {
      data: { ...e, typeLabel: label },
      style: {
        backgroundColor: color,
        borderColor: color,
        shape: 'ellipse',
      },
    };
  });

  const centerNode = styledNodes.find((n) => n.data.id === sourceNodeId);
  if (centerNode) {
    centerNode.style.shape = 'star';
  }

  return styledNodes;
}

function getDataColoredEdges(edges: GraphEdge[], nodes: GraphNode[]) {
  return edges.map((e) => {
    const targetNode = nodes.find((n) => e.target === n.id);
    const color = targetNode
      ? laIdTypeColorAssignment.getItem(targetNode.type).color
      : '#CBCCCD';
    return { data: e, style: { 'line-color': color } };
  });
}
